import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ConfigService } from '../shared/config';
import { CategoryData } from '../admin-dashboard/category/category.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private afs: AngularFirestore, private configService: ConfigService) { }

  getCompanyId(): string {
    return this.configService.getCompanyId();
  }
  updateCategory(data: CategoryData): Promise<void> {
  const companyId = this.configService.getCompanyId();

  if (!data.dbid) {
    return Promise.reject('Missing dbid in CategoryData');
  }
  return this.afs
    .collection('company')
    .doc(companyId)
    .collection('categories')
    .doc(data.dbid)
    .update({
      name: data.name,
      shelf: data.shelf,
      maxLife: data.maxLife,
      svinnStatus: data.active,
    });
}
  getCategoryById(id: string) {
    const companyId = this.configService.getCompanyId();
    return this.afs
      .collection('company')
      .doc(companyId)
      .collection('categories')
      .doc(id)
      .valueChanges();
  }
  createCategory(data: CategoryData): Promise<void> {
  const companyId = this.configService.getCompanyId();
  const newDocRef = this.afs.collection('company')
    .doc(companyId)
    .collection('categories')
    .doc(); 

  const newCategory = {
    dbid: newDocRef.ref.id,
    name: data.name,
    shelf: data.shelf,
    maxLife: data.maxLife,
    svinnStatus: data.active ?? true,
  };

  return newDocRef.set(newCategory);
}


}